// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230715/js/" + chunkId + "." + {"44":"eafc5d11","225":"4ea86f00","481":"a5083736","486":"6e76e48b","770":"20222e49"}[chunkId] + ".0.7838148992339931.chunk.js";
};